<app-create-asin-header></app-create-asin-header>

<div class="land-bg" style="{{minHeight}}">

    <div class="container mb-4" style="{{minHeight2}}">
        <div style="padding: 50px 30px;">
            <div class="row justify-content-center">
                <div class="col-md-8">
                    <div class="question-card">
                        <div class="btn btn-dark" (click)="goBack.emit()">Back</div>
                        <h4 class="text-center mb-4">CAPTURE IMAGE</h4>
                        <div class="row justify-content-center">
                            <div class="col-md-6">
                                <div class="image-div">

                                    <img *ngIf="ninDetails?.photo && cameraMode === 'waiting'" style="width: 100% !important; aspect-ratio: 1; object-fit: cover; margin-bottom: 5px;" [src]="ninDetails?.photo" alt="Image Preview" />
                                    <img *ngIf="cameraMode === 'waiting' && !ninDetails?.photo" style="width: 100% !important;" [src]="'assets/create-asin/capture-image.svg'" alt="Image Preview" />

                                    <div *ngIf="cameraMode === 'capture'">
                                        <video #video width="400" height="400" autoplay muted *ngIf="!image"></video>
                                    </div>

                                    <div [hidden]="cameraMode !='redo'">
                                        <canvas #canvas width="400" height="400"  style="display: none" ></canvas>
                                    </div>

                                    <p *ngIf="cameraMode === 'capture'"> {{message}} </p>

                                    <!-- <img *ngIf="cameraMode === 'redo'" [src]="capturedImage" style="width: 100%" alt="Captured Image"> -->
                                </div>

                                <br />

                                <div class="d-flex flex-row flex-wrap justify-content-between gap-1 p-0">
                                        <ng-container>
                                            <button class="capture-button flex-1 bg-dark" *ngIf="cameraMode === 'waiting'" (click)="startCamera()">Start Capture</button>
                                            <button class="capture-button flex-1 bg-dark" *ngIf="cameraMode === 'capture' && !isloading" (click)="capture()">Capture Image</button>
                                            <div class="spinner" *ngIf="cameraMode === 'capture' && isloading"></div>
                                            <button class="capture-button flex-1 bg-dark" *ngIf="cameraMode === 'redo'" (click)="startCamera()">Capture Again</button>
                                        </ng-container>

                                        <ng-container>
                                            <button class="capture-button " (click)="continue()" style="background: {{cameraMode === 'redo' ? '#07670f' : '#0E831733'}}" [disabled]="cameraMode !== 'redo'" *ngIf="!ninDetails?.photo || cameraMode == 'redo'">
                                                <div class="spinner me-2" *ngIf="isSubmitting"></div>
                                                <span *ngIf="isSubmitting">Loading</span>
                                                <span *ngIf="!isSubmitting">Continue</span>
                                            </button>
                                            <button class="capture-button" (click)="continueWithNin()" style="background: {{ninDetails?.photo ? '#07670f' : '#0E831733'}}" *ngIf="ninDetails?.photo && cameraMode !== 'redo'">
                                                <div class="spinner me-2" *ngIf="isSubmitting"></div>
                                                <span *ngIf="isSubmitting">Loading</span>
                                                <span *ngIf="!isSubmitting">Continue with NIN Image</span>
                                            </button>
                                        </ng-container>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>

<!--style="background: {{cameraMode === 'redo' ? '#07670f' : '#0E831733'}}"-->
